import { render, staticRenderFns } from "./DeliverySpaceDetail.vue?vue&type=template&id=38502595&"
import script from "./DeliverySpaceDetail.vue?vue&type=script&lang=ts&"
export * from "./DeliverySpaceDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports